import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PACIFIC_PETITION_PROMOTION_CONFIG = createFcmDetails('pacific_petition_promotion_config', {
	owner: 'Monetization',
	context: 'Starter Dashboard',
	description: `
Used to prevent promotions from being shown on specific petitions.
`,
	template: {
		block_all: false,
		block_petition_ids: [1234, 5678],
	},
	import: false,
});
